import { render, staticRenderFns } from "./RemainingCount.vue?vue&type=template&id=54caa4a6&"
import script from "./RemainingCount.vue?vue&type=script&lang=js&"
export * from "./RemainingCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports